
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>

        
          <Container style={{marginBottom:"2.5rem", fontWeight:"500", textAlign:"start", color:"#43ACE7",}}>
           <h1 style={{color:"#43ACE7", textAlign:"center"}}>
            <strong >Hammaste valgendus</strong>
          </h1>
            <p style={{color:"#43ACE7", fontWeight:"500", textAlign:"start"}}></p>
            <h4 style={{ color: "#43ACE7", fontWeight: "500" }}>

      </h4>

      <p>
                Ohutu ja tõhus protseduur, mis muudab hambad märgatavalt heledamaks ning taastab naeratuse värskuse ja sära.

Kasutame professionaalseid meetodeid, mis on hambasõbralikud ja annavad ühtlase, loomuliku tulemuse, sobides nii iseseisva protseduurina kui ka osana esteetilisest naeratuse kujundamisest. Nõustame valgenduse meetodi valikul.
      </p>

      </Container>
          </Container>

        </div>
    );
}